import { Layout as AntdLayout } from 'antd'
import type { SiderProps as AntdSiderProps } from 'antd/lib/layout'

type SiderProps = AntdSiderProps

export function Sider(props: SiderProps) {
  return <AntdLayout.Sider {...props} />
}
